var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#chart--line_svg__clip0_61530_7232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.502 21l4.793-9 5.475 4.867a1.5 1.5 0 002.34-.45l4.14-8.242-1.365-.675-4.118 8.25-5.474-4.867a1.5 1.5 0 00-1.26-.383 1.5 1.5 0 00-1.065.75L3 18.75V1.5H1.5V21A1.5 1.5 0 003 22.5h19.5V21H3.503z",
    fill: "#45464F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "chart--line_svg__clip0_61530_7232"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgChartLine;